import React from 'react'
import { SalePayment, SwiperPaymentOption } from './types'

type Props = {
  paymentOptions: SwiperPaymentOption
  onSuccess?: (result: SalePayment) => void
  onClose: () => void
}

export const SwiperPayment = ({
  paymentOptions,
  onSuccess,
  onClose,
}: Props) => {
  // Placeholder for Swiper payment implementation
  return <></>
}
